import type { ManagerRegistry } from '../../../core/manager-registry';
import type { RadialMenuItem } from '../types';
import { getIcon } from '../../../utils/icon-manager';

export const createSettingRadialButton = (registry: ManagerRegistry): RadialMenuItem => {
    return {
        id: 'setting',
        label: 'toolbar.setting',
        icon: getIcon('设置'),
        onClick: () => {
            registry.setting?.toggle();
            console.log(`[RadialToolbar] 设置${registry.setting?.isOpen() ? '已打开' : '已关闭'}`);
        }
    };
};
